<template>
  <el-container class="home-container" id="full-height">
    <el-header>
      <Header @openQualityTesting="openzhijian" />
    </el-header>
    <el-container class="content_container">
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <div class="colse_remind" v-if="!showremind && haveremind">
      <i class="el-icon-top-left" @click="openremind()"></i>

    </div>
    <div class="remind_box" v-if="showremind && haveremind">
      <div class="remind_text">
        <!-- A!提醒: -->
        {{ reminddetail.des }}
        <span style="color: #b50000;">
          <!-- 2025年4月17日16时20分，生物风机P-1011A的风压达到设定的安全上限2000Pà。 -->
        </span>
        <!-- AI调控将优先确保设备安全，短时间内D0指标可能会偏离目标值。 -->
      </div>
      <div class="remind_more" @click="opendrawer(reminddetail.msg_detail.rule_id)">
        历史提醒
      </div>
      <i class="el-icon-bottom-right" @click="closeremind()"></i>
    </div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="dialogbigtitle">
        <div class="titlebg">
          <span class="titlespan"> 质检 </span>
        </div>
      </div>
      <div class="dialogtitle">
        <div class="titlebg">
          <span class="titlespan"> 仪表质检: </span>
          <img src="../assets/加@2x.png" alt="" @click="changeadd()" v-if="!addtype" />
          <el-cascader ref="cascaderArr" :options="options" :props="props" clearable v-if="addtype" collapse-tags
            @change="onChange"></el-cascader>
        </div>
      </div>
      <div class="zhijiantable">
        <div class="border">
          <p class="borderspan" v-if="inglist.length < 1">
            暂无正在质检中仪表。点击“+”号添加！
          </p>
          <div class="tagbox">
            <el-tag class="eltag" v-for="(item, index) in inglist" closable :key="index" @close="closetag(item)">{{
              item.name }}</el-tag>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commitchange1()">确认</el-button>
        <el-button @click="colsedialog1()">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="beidong" :visible.sync="beidongdialogVisible" :before-close="handleClose"
      :close-on-click-modal="false" center :showClose="false" :width="mywidth">
      <div class="dialogtitle">
        <div class="titlebg">
          <img src="../assets/警告@2x.png" alt="" />
          <span> 请确认以下告警是否异常 </span>
          <!-- {{ roleBtnCodes }} -->
        </div>
      </div>
      <div class="dialogtable">
        <el-table :data="warningalarms" style="width: 100%" @selection-change="handleSelectionChange" max-height="350">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="module_name" label="告警模块" min-width="20%">
          </el-table-column>
          <el-table-column prop="time" label="开始时间" min-width="30%">
          </el-table-column>
          <el-table-column prop="des" label="当前告警"> </el-table-column>
          <el-table-column prop="des" label="操作">
            <template slot-scope="scope">
              <div class="watchhistory" @click="openwidth(scope.row)">
                <div>查看趋势</div>
                <img src="../assets/路径 2 (1).png" alt="" />
                <img src="../assets/路径 2 (1).png" alt="" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="chart" v-if="openchart">
        <chartCpn ref="child" :codMain="'myChart_alarms'" :ChartData="ChartData" style="width: 900px; height: 450px">
        </chartCpn>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="commitchange()" class="commit">是</el-button>
        <el-button @click="colsedialog()" class="nocommit">否</el-button>
      </span>
    </el-dialog>
    <el-dialog custom-class="beidong warn-dialog" :visible.sync="gaojingdialogVisible" :before-close="onClose"
      :close-on-click-modal="false" center width="40%">
      <div style="display: flex">
        <div class="warning_box">
          <span class="close-hint">已知晓<br />去排查</span>
          <div class="dialogtitle">
            <div class="titlebg">
              <img src="../assets/警告@2x.png" alt="" />
              <span> 请确认以下告警是否异常 </span>
            </div>
          </div>
          <div class="dialogtable">
            <el-collapse v-model="collapseActive" accordion @change="onCollapseChange">
              <div v-for="(item, index) in warningList" :key="index">
                <el-collapse-item :name="index">
                  <template slot="title">
                    <div class="title">
                      <div class="name">
                        <span>【{{ item.name }}】</span>{{ item.des }}
                      </div>
                      <div class="time">告警时间：{{ item.created_at }}</div>
                    </div>
                  </template>
                  <div class="content_attribute">
                    <div class="warning_detail">
                      <span>
                        告警点位为：
                        <span v-for="(tag, i) in item.msg_detail.tags_value" :key="i">
                          {{ tag.name }}
                        </span>
                      </span>
                    </div>
                    <div class="warning_detail">
                      <span>
                        点位值为：
                        <span v-for="(tag, i) in item.msg_detail.tags_value" :key="i">
                          {{ tag.value }}
                        </span>
                      </span>
                    </div>
                    <chartCpn v-if="openAchart && collapseActive === index" ref="child" :codMain="'warningDialogChart'"
                      :ChartData="ChartData" style="width: 100%; height: 300px">
                    </chartCpn>
                  </div>
                </el-collapse-item>
                <div class="footer">
                  <el-radio-group v-model="item.handleType">
                    <el-radio label="1">已知晓，去排查</el-radio>
                    <el-radio label="2">已排查，去填写原因</el-radio>
                  </el-radio-group>
                  <el-button @click="handleWarning(item)">提交</el-button>
                  <div class="cause-select" v-if="item.handleType == '2'">
                    <span>请选择原因：</span>
                    <el-radio-group v-model="item.alarmCause" @input="onCauseChange(item, $event)">
                      <el-radio label="数据值可信">数据值可信</el-radio>
                      <el-popover placement="bottom" :width="120" trigger="click">
                        <button class="wrap-btn" @click.prevent="onCauseChange(item, '数据值不可信')" slot="reference">
                          <el-radio label="数据值不可信">数据值不可信</el-radio>
                        </button>
                        <el-checkbox-group v-model="item.causeList">
                          <el-checkbox label="传感器故障"></el-checkbox>
                          <el-checkbox label="执行机构故障"></el-checkbox>
                          <el-checkbox label="设备掉线"></el-checkbox>
                          <el-checkbox label="现场断电"></el-checkbox>
                          <el-checkbox label="网络失联"></el-checkbox>
                        </el-checkbox-group>
                      </el-popover>
                      <el-radio label="其他原因">其他原因</el-radio>
                    </el-radio-group>
                    <el-input type="textarea" v-model="item.otherReason" rows="3" v-if="item.alarmCause === '其他原因'" />
                  </div>
                </div>
              </div>
            </el-collapse>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-drawer title="历史AI提醒" :visible.sync="drawer" :before-close="drawerhandleClose">
      <div class="remindhistory_box">
        <el-date-picker v-model="value1" value-format="yyyy-MM-dd" align="center" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="changedata()">
        </el-date-picker>
        <div class="remindhistory_box2" v-for="item in historydetail" :key="item.id">
          <div class="remindhistory_text">
            <p>
              {{ item.noti_detail }}
              <!-- 2025年4月17日16时20分，生物风机P-1011A的风压达到设定的安全上限2000Pa -->
            </p>
            <p>
              <!-- AI调控将优先确保设备安全，短时间内D0指标可能会偏离目标值。 -->
            </p>
          </div>
          <div class="remindhistory_charts">
            <!-- :firstindex="firstindex" :toolboxShow="toolboxShow" -->
            <maincharts :key="item.id" :codMain="'bigchart' + '-' + item.id" :ChartData="item.chat" class="mainchart">
            </maincharts>
          </div>
        </div>
        <div class="remindhistory_footer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[2, 4, 8]"
            :page-size="100" layout="->,total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-drawer>
    <audio controls loop ref="warningAudio" hidden>
      <source src="../assets/sound.mp3" type="audio/mpeg" />
    </audio>
    <dealdialog :title="dialogtitle" :infoid="infoid" :dealdialogVisible="dealdialogVisible" @closedrawer="closedrawer"
      v-if="dealdialogVisible">
    </dealdialog>
    <EarlyWarningDialog :visible="earlyWarningVisible" :dataList="earlyWarningData"
      @onClose="earlyWarningVisible = false" />
    <AIWarningDialog :visible="AIWarningVisible" :dataList="AIWarningList" @onClose="AIWarningVisible = false" />
  </el-container>
</template>

<script>
import Header from "./Header/index.vue";
// import Header from "./Header/iotindex.vue";
import chartCpn from "@/components/component/maincharts.vue";
import dealdialog from "../views/WarningCenter/component/dealdialog.vue";
import qs from "qs";
import config from "@/utils/config.js";
import axios from "axios";
import EarlyWarningDialog from "./components/EarlyWarningDialog.vue";
import AIWarningDialog from "./components/AIWarningDialog.vue";
import maincharts from "../components/component/remindcharts.vue";


export default {
  components: { Header, chartCpn, dealdialog, EarlyWarningDialog, AIWarningDialog, maincharts },
  data() {
    return {
      collapseActive: undefined,
      dealindex: null,
      dealdialogVisible: false,
      dialogtitle: null,
      infoid: null,
      options: [
        { value: "lightTheme", label: "白色模式" },
        { value: "blackTheme", label: "深色模式" },
      ],
      warningABCurrent: null,
      warningA: null,
      gaojingdialogVisible: false,
      earlyWarningData: [],
      earlyWarningVisible: false,
      percent: 0,
      show: false,
      type: null,
      value: true,
      title: null,
      dialogVisible: false,
      addtype: false,
      props: {
        multiple: true,
        value: "all",
        label: "name",
        children: "child",
        disabled: "state",
      },
      inglist: [],
      ids: null,
      tags: null,
      beidongdialogVisible: false,
      warningalarms: [],
      allalarms: [],
      multipleSelection: null,
      alarmindex: 0,
      mywidth: "50%",
      openchart: false,
      ChartData: null,
      openAchart: false,
      warningList: [],
      roleBtnCodes: [],
      AIWarningVisible: false,
      AIWarningList: [],
      drawer: false,
      showremind: false,
      haveremind: false,
      reminddetail: null,
      historydetail: null,
      historychart: null,
      value1: [],
      page: 1,
      pageSize: 2,
      total: null,
      tenantSpell: undefined,
    };
  },
  mounted() {
    const fullHeightElement = document.getElementById('full-height');
    this.setFullHeight(fullHeightElement);
    const zoom = this.getZoomRatio();
    const element = document.getElementById('full-height');
    console.log(zoom, 'zonm');

    // 根据缩放比例调整尺寸
    if (zoom < 1) { // 缩小状态
      element.style.transform = `scaley(${1 / zoom})`;
      element.style.transformOrigin = 'top left';
    } else {
      element.style.transform = 'none';
    }
    window.addEventListener('resize', () => {
      const zoom = this.getZoomRatio();
      const element = document.getElementById('full-height');
      console.log(zoom, 'zonm');

      // 根据缩放比例调整尺寸
      if (zoom < 1) { // 缩小状态
        element.style.transform = `scaley(${1 / zoom})`;
        element.style.transformOrigin = 'top left';
      } else {
        element.style.transform = 'none';
      }
    });

  },
  created() {
    this.getModulesInitall();
    console.log(this.warningalarms);

    this.getUrlConfig();
  },
  watch: {
    "$store.state.tenantIds": {
      handler(newValue) {
        const tenantIds = newValue;
        let tenantId = sessionStorage.getItem("tenantId");
        console.log('current path', this.$route.path, '------------------');
        for (let key in tenantIds) {
          if (tenantIds[key] == tenantId) {
            this.tenantSpell = key;
          }
        }
        if (this.$route.path === '/ai/control') {
          if (tenantId == tenantIds.shandongtaikai) {
            this.gotoinfo(0);
          }
        }
      },
      immediate: true,
    },
    "$store.state.roleBtnCodes": {
      handler(val) {
        this.roleBtnCodes = val || [];
      },
      immediate: true,
    },
  },
  methods: {
    //跳转详情页
    async gotoinfo(index) {
      const { data: res } = await this.$http.get(
        config.httpPrefix + "/modules/facilities",
        {
          params: { index: index },
        }
      );
      const { data: res1 } = await this.$http.get(config.httpPrefix + "/modules/chart", {
        params: { index: index },
      });
      const length = res.data.result.facilities.length;
      console.log(index, length, 'index, length----------------')
      this.$router.push({
        path: "/openMore",
        query: { index: index, length: length },
      });
    },
    getModulesInitall() {
      let modulesInitall = this.$store.state.modulesInitallData;
      if (!modulesInitall.length) {
        this.$store.dispatch("getModulesInitall");
      }
    },
    async openwidth(item) {
      console.log(item);
      let tags = item.tag;
      // item.msg_detail.tags_value.map(v => {
      //   tags.push(v.tag)
      // })
      console.log(tags);
      // return
      const { data: res } = await this.$http.get(config.httpPrefix + "/msg/trend/tags", {
        params: {
          tags: tags,
          trend_scope: 720,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      this.ChartData = res.data;
      this.openchart = true;
      this.mywidth = "60%";
    },
    onCollapseChange(index) {
      const data = this.warningList[index];
      this.openAwidth(data);
    },
    async openAwidth(item) {
      console.log(item);
      let tags = [];
      item.msg_detail.tags_value.map((v) => {
        tags.push(v.tag);
      });
      console.log(tags);
      const { data: res } = await this.$http.get(config.httpPrefix + "/msg/trend", {
        params: {
          id: item.id,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      this.ChartData = res.data;
      this.openAchart = true;
    },
    handleWarning(record = {}) {
      console.log(record);
      if (!record.handleType) {
        this.$message.warning("请选择告警原因");
        return;
      }
      const handleWarningList = () => {
        this.warningList = this.warningList.filter((item) => {
          return item.source_id !== record.source_id;
        });
        if (this.warningList.length) {
          let needAudioWarn = false,
            needLightWarn = false;
          this.warningList.map((item) => {
            if (item.msg_detail.level_name === "A") {
              needAudioWarn = true;
            }
            if (item.msg_detail.level_name === "B") {
              needLightWarn = true;
            }
          });
          if (!needAudioWarn && !needLightWarn) {
            axios.post(
              config.httpPrefix +
              "/msg/alarm/remind?instruct=redClose&instruct=buzzerClose"
            );
          } else if (!needAudioWarn && needLightWarn) {
            axios.post(config.httpPrefix + "/msg/alarm/remind?instruct=buzzerClose");
          }
        } else {
          this.gaojingdialogVisible = false;
          axios.post(
            config.httpPrefix + "/msg/alarm/remind?instruct=redClose&instruct=buzzerClose"
          );
        }
      };
      if (record.handleType === "1") {
        this.$http
          .put(config.httpPrefix + "/msg/remind/update", {
            id: [record.id],
            remind_interval: 30,
          })
          .then((res) => {
            if (res.data && res.data.code === 200) {
              handleWarningList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        if (!record.alarmCause) {
          this.$message.warning("请选择告警原因");
          return;
        }
        let reason = [];
        if (record.alarmCause === "数据值可信") {
          reason = ["数据值可信"];
        } else if (record.alarmCause === "数据值不可信") {
          if (!record.causeList.length) {
            this.$message.warning("请选择告警原因");
            return;
          }
          reason = [...record.causeList];
        } else {
          if (!record.otherReason) {
            this.$message.warning("请填写告警原因");
            return;
          }
          reason = [record.otherReason];
        }
        this.$http
          .put(config.httpPrefix + `/alarm/record/deal?id=${record.source_id}`, {
            status: 2,
            handle_reason: reason,
          })
          .then((res) => {
            if (res.data && res.data.code === 200) {
              handleWarningList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    onClose() {
      const ids = this.warningList.map((item) => item.id);
      this.$http
        .put(config.httpPrefix + "/msg/remind/update", {
          id: ids,
          remind_interval: 30,
        })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.gaojingdialogVisible = false;
            axios.post(
              config.httpPrefix +
              "/msg/alarm/remind?instruct=redClose&instruct=buzzerClose"
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    changeadd() {
      this.addtype = true;
    },
    colsedialog1() {
      this.addtype = false;
      this.dialogVisible = false;
    },
    async commitchange1() {
      if (this.ids.length > 0) {
        const { data: res1 } = await this.$http.post(
          config.httpPrefix + "/abwarning/statechange",
          {
            ids: this.ids,
            tags: this.tags,
            state: true,
          }
        );
        if (res1.meta.status == 200) {
          // this.openzhijian()
          this.addtype = false;

          this.dialogVisible = false;
          return this.$message.success(res1.meta.msg);
        }
      }
      this.addtype = false;
      this.dialogVisible = false;
    },
    async closetag(value) {
      console.log(value);
      const { data: res1 } = await this.$http.post(
        config.httpPrefix + "/abwarning/statechange",
        {
          ids: [value.id],
          tags: [value.tag],
          state: false,
        }
      );
      if (res1.meta.status == 200) {
        this.openzhijian();
        return this.$message.success(res1.meta.msg);
      }
    },
    async onChange(value) {
      console.log(value);
      let ids = [];
      let tags = [];
      for (let a = 0; a < value.length; a++) {
        // console.log(value[a]);
        ids.push(value[a][1].id);
        tags.push(value[a][1].tag);
      }
      // console.log(ids);
      this.ids = ids;
      this.tags = tags;
    },
    async openzhijian() {
      this.ids = [];
      this.tags = [];
      let arr = [];
      const { data: res } = await this.$http.get(
        config.httpPrefix + "/abwarning/qualityinfo"
      );
      console.log(res);
      for (let a = 0; a < res.data.length; a++) {
        for (let b = 0; b < res.data[a].child.length; b++) {
          // console.log(res.data[a].child[b]);
          res.data[a].child[b].all = {
            id: res.data[a].child[b].id,
            name: res.data[a].child[b].name,
            tag: res.data[a].child[b].tag,
          };
        }
        arr.push({
          id: res.data[a].group,
          name: res.data[a].groupname,
          child: res.data[a].child,
          all: {
            id: res.data[a].group,
            name: res.data[a].groupname,
          },
        });
      }
      console.log(arr);
      this.options = arr;
      let truelist = [];
      for (let b = 0; b < this.options.length; b++) {
        for (let c = 0; c < this.options[b].child.length; c++) {
          if (this.options[b].child[c].state) {
            truelist.push(this.options[b].child[c]);
          }
        }
      }
      this.inglist = truelist;
      this.dialogVisible = true;
    },
    handleClose() {
      this.addtype = false;
      this.dialogVisible = false;
    },
    async commitchange() {
      console.log(this.multipleSelection);
      if (this.multipleSelection) {
        let arr = [];
        for (let a = 0; a < this.multipleSelection.length; a++) {
          arr.push({
            tag: this.multipleSelection[a].tag,
            alarm: this.multipleSelection[a].alarm,
            value: this.multipleSelection[a].value,
            time: this.multipleSelection[a].time,
            des: this.multipleSelection[a].des,
            module: this.multipleSelection[a].module,
            confirm: 1,
          });
        }
        const { data: res } = await this.$http.post(
          config.httpPrefix + "/abwarning/confirm",
          {
            data: arr,
          }
        );
        if (res.meta.status == 200) {
          // this.openzhijian()
          this.$message.success(res.meta.msg);

          // arr = arr.filter(item => item != element)
          for (let a = 0; a < this.multipleSelection.length; a++) {
            this.warningalarms = this.warningalarms.filter(
              (item) => item.id != this.multipleSelection[a].id
            );
            for (let b = 0; b < this.allalarms.length; b++) {
              this.allalarms[b].alarms = this.allalarms[b].alarms.filter(
                (item) => item.id != this.multipleSelection[a].id
              );
            }
          }
          // this.warningalarms
          if (this.warningalarms.length < 1) {
            this.beidongdialogVisible = false;
          }
        } else {
          this.$message.warning("异常告警处理失败");
        }
      } else {
        return this.$message.warning("未选中任何告警");
      }
    },
    async colsedialog() {
      // console.log(this.multipleSelection);
      if (this.multipleSelection) {
        let arr = [];
        for (let a = 0; a < this.multipleSelection.length; a++) {
          arr.push({
            tag: this.multipleSelection[a].tag,
            alarm: this.multipleSelection[a].alarm,
            value: this.multipleSelection[a].value,
            time: this.multipleSelection[a].time,
            des: this.multipleSelection[a].des,
            module: this.multipleSelection[a].module,
            confirm: 0,
          });
        }
        const { data: res } = await this.$http.post(
          config.httpPrefix + "/abwarning/confirm",
          {
            data: arr,
          }
        );
        if (res.meta.status == 200) {
          // this.openzhijian()
          this.$message.success(res.meta.msg);
          // arr = arr.filter(item => item != element)
          for (let a = 0; a < this.multipleSelection.length; a++) {
            this.warningalarms = this.warningalarms.filter(
              (item) => item.id != this.multipleSelection[a].id
            );
            for (let b = 0; b < this.allalarms.length; b++) {
              this.allalarms[b].alarms = this.allalarms[b].alarms.filter(
                (item) => item.id != this.multipleSelection[a].id
              );
            }
          }
          // console.log(this.allalarms);
          // console.log(this.warningalarms);
          // this.warningalarms
          if (this.warningalarms.length < 1) {
            this.beidongdialogVisible = false;
          }
        } else {
          this.$message.warning("异常告警处理失败");
        }
      } else {
        return this.$message.warning("未选中任何告警");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    gotodeal(item, index) {
      this.dealindex = index;
      this.infoid = item.id;
      this.dialogtitle = "处理原因说明";
      this.dealdialogVisible = true;
    },
    closedrawer() {
      this.dealdialogVisible = false;
      this.warningA.splice(this.dealindex, 1);
      if (this.warningA.length == 0) {
        this.gaojingdialogVisible = false;
        this.openAchart = false;
      }
    },
    onCauseChange(record = {}, value) {
      record.alarmCause = value;
      record.causeList = [];
    },

    getUrlConfig() {
      this.$http.get(config.httpPrefix + "/urlconfig").then((res) => {
        if (res.data && res.data.code === 200) {
          this.$store.commit("setUrlConfig", res.data.data.urlconfig);
        }
      });
    },
    closeremind() {
      this.showremind = false
    },
    openremind() {
      this.showremind = true
    },
    drawerhandleClose() {
      this.drawer = false
      this.value1 = []
      this.historydetail = null
    },
    changedata() {
      console.log(this.value1);
      this.opendrawer(this.chartid)

    },
    handleSizeChange(val) {
      this.pageSize = val
      // this.getall();
      this.opendrawer(this.chartid)
    },
    handleCurrentChange(val) {
      this.page = val
      this.opendrawer(this.chartid)
      // this.getall();
      // console.log(`当前页: ${val}`);
    },
    opendrawer(id) {
      this.chartid = id
      this.drawer = true
      console.log(1111111111111111111111111);

      this.$http.get(config.httpPrefix + "/alarm/rule/chart", {
        params: {
          id: id,
          page: this.page,
          size: this.pageSize,
          start_time: this.value1[0],
          end_time: this.value1[1],
        },
      }).then((res) => {
        if (res.data && res.data.code === 200) {
          console.log(res.data.data.data);
          this.historydetail = res.data.data.data
          this.total = res.data.data.total_count
        }
      });
    },
    setFullHeight(element) {

      const actualHeight = window.innerHeight;
      console.log(actualHeight);
      element.style.height = `${actualHeight}px`;
    },
    getZoomRatio() {
      return 1 / window.devicePixelRatio;
    }
  },
};
</script>
<style lang="scss" scoped>
.home-container {
  height: 100vh;

  .el-header {
    margin-bottom: 20px;
    padding: 0 !important;
    height: 60px !important;
  }
}

.colse_remind {
  position: absolute;
  left: 95%;
  top: 90%;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  box-shadow: 0 2px 12px 0 rgba(222, 60, 60, 0.25);
}

.mainchart {
  width: 100%;
  height: 400px;
  margin: 0 auto;
}

.remindhistory_box {
  margin-left: 10px;
  // background-color: #498af4;
}

.remind_box {
  z-index: 100;
  width: 60%;
  position: absolute;
  left: 50%;
  top: 51%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px;
  border-radius: 40px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(222, 60, 60, 0.25);

  .remind_text {
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // display: inline-block;
    display: flex;
    align-items: center;
  }

  .remind_more {
    // margin-left: 10%
    cursor: pointer;
    color: #498af4;
  }
}

.el-main {
  padding: 0;
}

.el-aside:hover .shoqibutton {
  display: inline-block !important;
  cursor: pointer;
}

.elAside {
  display: none !important;
}

::v-deep .el-switch {
  .el-switch__label * {
    line-height: 1;
    font-size: 12px;
    display: inline-block;
  }

  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
    font-size: 12px !important;
  }

  /*打开时文字位置设置*/
  .el-switch__label--right {
    z-index: 1;
    right: 22px;
  }

  /*关闭时文字位置设置*/
  .el-switch__label--left {
    z-index: 1;
    left: 22px;
  }

  /*显示文字*/
  .el-switch__label.is-active {
    display: block;
  }

  /*开关宽度*/
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 44px !important;
}

::v-deep .el-dialog {
  opacity: 1;
  background: rgba(255, 255, 255, 1);
}

.dialogbigtitle {
  display: flex;
  align-items: center;
  justify-content: center;

  .titlebg {
    width: 696.68px;
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 28.96px;
    color: rgba(77, 74, 74, 1);
  }
}

.dialogtitle {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  .titlebg {
    width: 696.68px;
    display: flex;
    align-items: center;
  }

  .titlespan {
    margin-right: 10px;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 20px;
  }

  span {
    font-size: 18px;
    font-weight: 400;
    color: rgba(77, 74, 74, 1);
    text-align: left;
    vertical-align: middle;
  }
}

.zhijiantable {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  .border {
    width: 696.68px;
    height: 240px;
    opacity: 1;
    border-radius: 12px;
    border: 0.8px solid rgba(73, 138, 244, 1);
    text-align: left;

    .borderspan {
      margin-left: 34px;
      margin-right: 34px;
      margin-top: 17px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(73, 138, 244, 1);
    }

    .tagbox {
      margin-left: 34px;
      margin-right: 34px;
      height: 250px;

      .eltag {
        margin-right: 20px;
        margin-top: 20px;
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
      }
    }
  }
}

.dialogtable {
  margin-top: 40px;
  margin: 10px 67px;

  .footer {
    padding: 10px 0 20px;
    font-size: 14px;
    border-bottom: 1px solid rgba(176, 176, 176, 1);

    span {
      color: rgba(184, 75, 75, 1);
    }

    .cause-select {
      margin-top: 12px;

      .wrap-btn {
        margin-right: 26px;
        background: none;
        border: none;
      }
    }

    ::v-deep {
      .el-radio-group {
        margin: 0 20px;

        .el-radio__label {
          font-size: 14px;
        }
      }

      .el-button {
        padding: 0;
        width: 106px;
        height: 36px;
        font-size: 14px;
        color: rgba(36, 102, 168, 1);
        border-radius: 38px;
        background: rgba(222, 232, 242, 1);
        border: 1px solid rgba(172, 197, 222, 1);
      }
    }
  }

  .content_attribute {
    margin-bottom: 20px;

    .warning_detail {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(103, 103, 103, 1);
    }
  }

  .watchhistory {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 19px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 18.75px;
    color: rgba(36, 102, 168, 1);

    div {
      margin-right: 10px;
    }

    img {
      height: 14px;
    }
  }

  .commit_box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .commit_btn {
      display: flex;

      .myflex {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .ikonw {
        color: rgba(103, 103, 103, 1);
        margin-right: 20px;
        width: 105px;
        height: 36px;
        opacity: 1;
        border-radius: 38px;
        background: rgba(230, 231, 236, 1);
      }

      .goto {
        color: rgba(255, 255, 255, 1);
        width: 105px;
        height: 36px;
        opacity: 1;
        border-radius: 38px;
        background: rgba(36, 102, 168, 1);
      }
    }
  }

  ::v-deep .el-collapse-item__header {
    position: relative;
    padding: 16px 0;
    height: auto;
    line-height: 22px;
    border: none;
    align-items: flex-start;

    .title {
      padding-right: 40px;
    }

    .name {
      font-size: 18px;

      span {
        color: rgba(184, 75, 75, 1);
      }
    }

    .time {
      margin-top: 10px;
      font-size: 14px;
    }

    .el-collapse-item__arrow {
      position: relative;
      margin-top: 6px;

      &::after {
        content: "详情";
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 14px;
        color: #606266;
        white-space: nowrap;
        transform: translateY(-50%);
      }
    }

    .el-collapse-item__arrow.is-active {
      &::after {
        display: none;
      }
    }
  }

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    //滑块部分
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  .codMain {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    z-index: 99;
  }
}

::v-deep .el-dialog.beidong {
  width: 1000px;
  opacity: 1;
  border-radius: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 12px 50px 9px rgba(222, 60, 60, 0.25);

  .el-dialog__body {
    max-height: 900px;
    overflow: auto;
  }
}

.beidong {
  display: flex;

  .chart {
    margin-top: 80px;
  }

  .warning_box {
    position: relative;
    width: 100%;

    .close-hint {
      position: absolute;
      top: -20px;
      right: 0;
      font-size: 14px;
    }
  }

  .dialogtitle {
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    .titlebg {
      width: 795px;
      border-radius: 159px;
      background: rgba(254, 236, 234, 1);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 30px;
      height: 26px;
    }

    span {
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 58px;
      color: rgba(212, 48, 48, 1);
      text-align: left;
      vertical-align: middle;
    }
  }

  .commit {
    font-size: 18px;
    width: 96.32px;
    height: 45px;
    border-radius: 4px;
    background: rgba(236, 245, 255, 1);
    border: 0.5px solid rgba(73, 162, 255, 1);
    margin-right: 125px;
    margin-bottom: 40px;
  }

  .nocommit {
    font-size: 18px;
    width: 96.32px;
    height: 45px;
    border-radius: 4px;
    background: rgba(236, 245, 255, 1);
    border: 0.5px solid rgba(73, 162, 255, 1);
    margin-bottom: 40px;
  }
}
</style>

<style lang="scss">
.warning-notification {
  width: 480px !important;
  box-shadow: 0px 0px 50px 10px rgba(222, 60, 60, 0.25) !important;
  z-index: 3333 !important;

  .el-notification__group {
    width: 100%;
  }

  .title {
    span {
      color: rgba(184, 75, 75, 1);
    }
  }

  .time {
    margin-top: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .handle-btn {
    display: flex;
    width: 105px;
    height: 36px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(36, 102, 168, 1);
    background: rgba(36, 102, 168, 0.15);
    border: 1px solid rgba(36, 102, 168, 0.38);
    border-radius: 38px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
